import { OkrSession, OkrObjective, OkrKeyResult } from "server/models"
import { OrderType } from "client/utils"

export interface OkrObjectiveProps {
    sessionId: number
    objectiveId: number
    search: string // inbuilt router property
}
export interface OkrObjectiveObjectProps {
    objective: OkrObjective
}

export interface KeyResultNested {
    keyResult: OkrKeyResult
    nestedObjectives: readonly ObjectiveNested[]
}
export interface ObjectiveNested {
    objective: OkrObjective
    nestedKeyResults: readonly KeyResultNested[]
    nestedObjectives: readonly ObjectiveNested[]
}

export interface OkrObjectiveList { [objectiveId: number]: OkrObjective }
export type OkrObjectiveValidation = { [key in keyof OkrObjective]?: string}

export interface OkrObjectiveFilters {
    title?: string
    objectiveOwner?: number
    keyResultOwner?: number
    search?: string
}

export interface OkrObjectiveState {
    baseRoute: string
    objectiveRoute: string

    objectiveList: OkrObjectiveList
    objectiveIds: readonly number[]
    objectiveEdit: OkrObjective

    // to select parent
    availableSessions: readonly OkrSession[]
    availableObjectives: { [sessionId: number]: readonly OkrObjective[] }
    availableKeyResults: { [sessionId: number]: readonly OkrKeyResult[] }

    sortColumn: keyof OkrObjective
    sortOrder: OrderType
    filters: OkrObjectiveFilters

    // popup menu
    active: OkrObjective
    menuShow: boolean
    menuTarget: any

    showConfirmDelete: boolean

    reloadList: boolean
    reloadEdit: boolean
}

export const OKR_OBJECTIVE_BASE_ROUTE = "OKR_OBJECTIVE_BASE_ROUTE"
export const OKR_OBJECTIVE_ROUTE = "OKR_OBJECTIVE_ROUTE"

export const OKR_OBJECTIVE_LIST = "OKR_OBJECTIVE_LIST"
export const OKR_OBJECTIVE_IDS = "OKR_OBJECTIVE_IDS"
export const OKR_OBJECTIVE_EDIT = "OKR_OBJECTIVE_EDIT"

// to select parent
export const OKR_OBJECTIVE_AVAILABLE_SESSIONS = "OKR_OBJECTIVE_AVAILABLE_SESSIONS"
export const OKR_OBJECTIVE_AVAILABLE_OBJECTIVES = "OKR_OBJECTIVE_AVAILABLE_OBJECTIVES"
export const OKR_OBJECTIVE_AVAILABLE_KEY_RESULTS = "OKR_OBJECTIVE_AVAILABLE_KEY_RESULTS"

export const OKR_OBJECTIVE_SORT = "OKR_OBJECTIVE_SORT"
export const OKR_OBJECTIVE_FILTERS = "OKR_OBJECTIVE_FILTERS"

// popup menu
export const OKR_OBJECTIVE_ACTIVE = "OKR_OBJECTIVE_ACTIVE"
export const OKR_OBJECTIVE_POPUP_MENU_SHOW = "OKR_OBJECTIVE_POPUP_MENU_SHOW"
export const OKR_OBJECTIVE_POPUP_MENU_TARGET = "OKR_OBJECTIVE_POPUP_MENU_TARGET"
export const OKR_OBJECTIVE_SHOW_CONFIRM_DELETE = "OKR_OBJECTIVE_SHOW_CONFIRM_DELETE"

export const OKR_OBJECTIVE_RELOAD_LIST = "OKR_OBJECTIVE_RELOAD_LIST"
export const OKR_OBJECTIVE_RELOAD_EDIT = "OKR_OBJECTIVE_RELOAD_EDIT"
